import { RootState } from "src/store/types";

export const quotationsSelector = (state: RootState) => state.quotations;
export const carriersSelector = (state: RootState) => state.quotations.carriers;
export const sortBySelector = (state: RootState) => state.quotations.sortBy;
